import 'proxy-polyfill/proxy.min.js';
import React from 'react';
import createReactClass from 'create-react-class';
import ReactDOM from 'react-dom';
import Bluebird from 'bluebird';
import '../../axiosConfig';

import RegisterContainer from './containers/registerContainer';
import RegisterNewUserContainer from './containers/registerNewUserContainer';

if (window.isNewUserRegister) {
    ReactDOM.render(<RegisterNewUserContainer/>, window.document.getElementById('wrapper'))
} else {
    ReactDOM.render(<RegisterContainer/>, window.document.getElementById('wrapper'))
}